let templateString = require('./error-state.html');

let skErrorStateController = function() {
  let ctrl = this;
  let isSuccess = false;

  ctrl.$onChanges = changes => {
    if (changes.isSuccess) {
      ctrl.isSuccess = changes.isSuccess.currentValue;
    }
  };
}

export let errorState = {
  template: templateString,
  bindings: {
    isSuccess: '<',
  },
  controller: skErrorStateController
};

angular.module('skykitProvisioning')
.component('errorState', errorState)
.controller('skErrorStateController', skErrorStateController)